import Noty from 'noty'

Noty.overrideDefaults({
  theme: 'sunset',
  timeout: 5500
})
